import { WorkSheetProductStatusModelType, WorkSheetProductStatusTypeKeys } from '@teinor/erp/types/company/order/sell/workSheet/workSheetProductStatus'
import { useMemo } from 'react'
import { ComponentWithPermissions } from '../../../../../../../../baseComponents/CreateRoutering/types'
import { DisplayStatusWithoutIcon } from '../../../../../../../../baseComponents/Displays/DisplayStatus'
import { permissionCheck } from '../../../../../../../../baseComponents/PermissionChecker/function'
import TwinTable from '../../../../../../../../baseComponents/TwinTable'
import BaseScreenTable from '../../../../../../../../baseComponents/TwinTable/BaseScreenTable'
import { TableComponentProps } from '../../../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { CustomRenderColor, EditRowNotLink, DeleteRow } from '../../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useWorkSheetProductStatusType from '../../../../../../../../utils/hooks/sells/orders/useWorkSheetProductStatus'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import ModalCEWorkSheetProductStatus from './ModalCEWorkSheetProductStatus'
import ModalDeleteWorkSheetProductStatus from './ModalDeleteWorkSheetProductStatus'
import WorkSheetProductStatusSortButton from './WorkSheetProductStatusSortButton'
import { useParams } from 'react-router-dom'

interface WorkSheetProductStatusesProps extends ComponentWithPermissions { }

const WorkSheetProductStatuses: React.FC<WorkSheetProductStatusesProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()
    const pageData = {
        title: t('WorkSheetProductStatus', 'Estado de hoja de trabajo'),
        newText: t('newStatus', 'Nuevo estado'),
    }

    return (
        <BaseScreenTable TableComponent={TableWorkSheetProductStatuses} CreateModalComponent={ModalCEWorkSheetProductStatus} EditModalComponent={ModalCEWorkSheetProductStatus} DeleteModalComponent={ModalDeleteWorkSheetProductStatus} pageData={pageData} userPermissions={userPermissions} />
    )
}

interface TableWorkSheetProductStatusesProps extends TableComponentProps { }

const TableWorkSheetProductStatuses: React.FC<TableWorkSheetProductStatusesProps> = ({ tableInstance, setTableInstance, userPermissions, setOpened }) => {
    const { t } = useTwinTranslation()
    const { WorkSheetGroupStatusId } = useParams()
    const extraWhereParams = { 'WorkSheetGroupStatusId': WorkSheetGroupStatusId ? parseInt(WorkSheetGroupStatusId) : null }
    const { workSheetProductStatus } = useWorkSheetProductStatusType()

    const columns: ColumnTableSchema<WorkSheetProductStatusModelType> = [
        {
            id: 'id',
            dataKey: 'id',
            label: t('id', 'ID'),
            sortable: true,
            width: 75
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            minWidth: 130,
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            }
        },
        {
            id: 'typeStatus',
            dataKey: 'typeStatus',
            label: t('status', 'Estado'),
            minWidth: 120,
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentsCustomSelectSearchBar',
                extraComponentData: { items: workSheetProductStatus, label: t('status', 'Estado') }
            },
            customRender: (parameterValue) => <DisplayStatusWithoutIcon text={workSheetProductStatus[parseInt(parameterValue) as WorkSheetProductStatusTypeKeys].name} colorText={workSheetProductStatus[parseInt(parameterValue) as WorkSheetProductStatusTypeKeys].colorText} />,
        },
        {
            id: 'color',
            dataKey: 'color',
            label: t('color', 'Color'),
            customRender: (parameterValue) => <CustomRenderColor value={parameterValue} />,
        },
        {
            id: 'order',
            dataKey: 'order',
            label: t('order', 'Orden'),
            sortable: true,
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRowNotLink key={'edit' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'edit', allRowData })} />
        },
        {
            id: 'delete',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => <DeleteRow key={'delete' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} />,
            havePermission: permissionCheck(userPermissions, 'delete')
        }
    ]
    const children = useMemo(() => <WorkSheetProductStatusSortButton tableInstance={tableInstance} userPermissions={userPermissions} />, [tableInstance, userPermissions])
    return (
        <TwinTable columns={columns} name='workSheetProductStatuses' getDataFrom='/api/app/order/sell/workSheet/workSheetProductStatus/getAllWorkSheetProductStatuses' setTableInstance={setTableInstance} defaultOrder={{ defaultOrderField: 'order', order: 'asc' }} hideLoadFiltersButton={true} hideChangeColumnsButton={false} extraWhereParams={extraWhereParams} >
            {children}
        </TwinTable>
    )
}

export default WorkSheetProductStatuses